import { useFirebaseAuth } from '@app/firebase/firebase_provider';

export const useIsAuthenticated = () => !!useFirebaseAuth();
